"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ECustomerStatus = void 0;
const class_validator_1 = require("class-validator");
const Resource_1 = __importDefault(require("../Resource"));
const classTransformer_1 = require("../classTransformer");
const User_1 = __importDefault(require("./User"));
const Office_1 = __importDefault(require("./Office"));
const Rule_1 = __importDefault(require("./Rule"));
class OfficeRole extends Resource_1.default {
    constructor() {
        super(...arguments);
        this.created_at = null;
        this.updated_at = null;
    }
}
exports.default = OfficeRole;
__decorate([
    (0, classTransformer_1.Expose)(),
    __metadata("design:type", String)
], OfficeRole.prototype, "uid", void 0);
__decorate([
    (0, classTransformer_1.Expose)(),
    (0, class_validator_1.IsNotEmpty)({ groups: ["createOfficeRole"], message: "Nom du rôle ne peut pas être vide" }),
    (0, class_validator_1.NotEquals)('', { groups: ["updateOfficeRole"], message: "Nom du rôle ne peut pas être vide" }),
    __metadata("design:type", String)
], OfficeRole.prototype, "name", void 0);
__decorate([
    (0, classTransformer_1.Expose)(),
    (0, class_validator_1.IsDate)(),
    __metadata("design:type", Object)
], OfficeRole.prototype, "created_at", void 0);
__decorate([
    (0, classTransformer_1.Expose)(),
    (0, class_validator_1.IsDate)(),
    __metadata("design:type", Object)
], OfficeRole.prototype, "updated_at", void 0);
__decorate([
    (0, classTransformer_1.Expose)(),
    (0, class_validator_1.IsNotEmpty)({ groups: ["createOfficeRole"], message: "Office is required" }),
    (0, class_validator_1.ValidateNested)({ groups: ["createOfficeRole"] }),
    (0, classTransformer_1.Type)(() => Office_1.default),
    __metadata("design:type", Office_1.default)
], OfficeRole.prototype, "office", void 0);
__decorate([
    (0, classTransformer_1.Expose)(),
    (0, class_validator_1.IsNotEmpty)({ message: "Rules are required" }),
    (0, class_validator_1.ValidateNested)({ groups: ["updateOfficeRole"] }),
    (0, classTransformer_1.Type)(() => Rule_1.default),
    __metadata("design:type", Array)
], OfficeRole.prototype, "rules", void 0);
__decorate([
    (0, classTransformer_1.Expose)(),
    (0, class_validator_1.ValidateNested)(),
    (0, classTransformer_1.Type)(() => User_1.default),
    __metadata("design:type", Array)
], OfficeRole.prototype, "user", void 0);
var ECustomerStatus;
(function (ECustomerStatus) {
    ECustomerStatus["VALIDATED"] = "VALIDATED";
    ECustomerStatus["PENDING"] = "PENDING";
    ECustomerStatus["ERRONED"] = "ERRONED";
})(ECustomerStatus || (exports.ECustomerStatus = ECustomerStatus = {}));
